<div class="report-popup-container">

  <div class="popup-header">
    <h2>Retrieve Reports</h2>
    <mat-icon class="close-btn" (click)="closeModal()">close</mat-icon>
  </div>

  <div class="popup-body">

    <!-- Vessel Name -->
    <div class="row align-items-center mb-3">
      <div class="col-md-4">
        <label>Continue with Meraki Voyage Number?</label>
      </div>
      <!-- <div class="col-md-8">
        <select class="form-control" [(ngModel)]="selectedVessel">
          <option value="" disabled>Select vessel</option>
          <option *ngFor="let v of vesselList" [value]="v">
            {{ v }}
          </option>
        </select>
      </div> -->
    </div>

    

    <!-- Buttons -->
    <div class="text-center mt-3">
      <button class="btn submit-btn" (click)="fetchReport()">
     YES
      </button>
      <button class="btn cancel-btn" (click)="closeModal()">
     NO
      </button>
    </div>

  </div>
</div>
